import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router/index'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
import Vuex from 'vuex'
import store from './store'
import { get } from './utils/helpers'

Vue.config.productionTip = false
Vue.prototype.get = get //注册全局变量原型
Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VueRouter)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(require('vue-wechat-title'))
Vue.use(Vuex)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')